/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgYoutube(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M19.62 3.802c.507.046.948.1 1.184.166a3.53 3.53 0 012.474 2.589c.325 1.803.483 3.632.472 5.464a29.757 29.757 0 01-.483 5.431 3.53 3.53 0 01-2.463 2.54l-.01.003c-.508.136-1.328.225-2.209.289-.902.066-1.935.11-2.908.138a138.84 138.84 0 01-3.598.058H12v-1.5h.076a114.967 114.967 0 001.018-.007c.669-.007 1.577-.021 2.539-.05a68.748 68.748 0 002.843-.135c.888-.065 1.571-.147 1.925-.241a2.03 2.03 0 001.406-1.437 28.25 28.25 0 00.443-5.087v-.008a28.249 28.249 0 00-.443-5.165 2.03 2.03 0 00-1.411-1.438c-.078-.022-.37-.067-.912-.116a53.23 53.23 0 00-1.964-.135 102.02 102.02 0 00-10.99.015c-.778.044-1.45.094-1.968.145-.544.053-.856.102-.958.13a2.03 2.03 0 00-1.41 1.439 28.25 28.25 0 00-.444 5.126v.009c-.01 1.727.137 3.452.441 5.153a2.03 2.03 0 001.405 1.368c.353.094 1.037.177 1.928.242.871.064 1.88.106 2.843.135a135.575 135.575 0 003.557.057H12v1.5h-.08a116.937 116.937 0 01-1.03-.007c-.675-.007-1.594-.022-2.567-.05a70.263 70.263 0 01-2.908-.139c-.881-.064-1.701-.154-2.209-.29h-.004a3.53 3.53 0 01-2.463-2.439.747.747 0 01-.017-.072A29.75 29.75 0 01.25 12.02a29.75 29.75 0 01.482-5.472 3.53 3.53 0 012.464-2.54c.253-.071.7-.13 1.22-.18a51.554 51.554 0 012.029-.15A103.515 103.515 0 0117.6 3.663c.792.042 1.484.09 2.02.139zm-10.247 4.3a.75.75 0 01.748-.004l5.75 3.27a.75.75 0 010 1.304l-5.75 3.27A.75.75 0 019 15.29V8.75a.75.75 0 01.373-.648zm1.127 1.937v3.962l3.483-1.98-3.483-1.982z'
      />
    </svg>
  );
}

export default SvgYoutube;
